<script setup>
defineProps({
  state: {
    type: String,
    default: "inactive",
    validator: (v) => ["success", "error", "inactive"].includes(v),
  },
});
</script>

<template>
  <span class="status-dot" :class="state" />
</template>

<style lang="scss" scoped>
@use "@/colors" as c;

.status-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &.success::before {
    background-color: c.$green;
  }

  &.error::before {
    background-color: c.$destructive;
  }

  &.inactive::before {
    background-color: c.$grey;
  }
}
</style>
